import React from 'react';
import PropTypes from 'prop-types';
import Loader from './Loader';

const Shimmer = ({ content, appName }) => {
  const loader = content || (window.ev_vp && window.ev_vp.templates && window.ev_vp.templates[appName]);
  return loader ? (
    <div
      className="shm-container"
      dangerouslySetInnerHTML={{
        __html: loader,
      }}
    />
  ) : <Loader />;
};

Shimmer.propTypes = {
  content: PropTypes.string,
  appName: PropTypes.string.isRequired,
};

Shimmer.defaultProps = {
  content: undefined,
};

export default Shimmer;
